import {
  UPDATE_COMMENTS_RELEVANT_BEGIN,
  UPDATE_COMMENTS_RELEVANT_SUCCESS,
  UPDATE_COMMENTS_RELEVANT_FAILURE,
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';

const FEED_ID_KEY = "feedId";

export function updateCommentsRelevant(props = {}) {
  return dispatch => {
    dispatch({
      type: UPDATE_COMMENTS_RELEVANT_BEGIN,
    });
    const url = `${apiEndPoints.comments.UPDATE_COMMENT_RELEVANT}?commentId=${props.commentOrPostId}&relevance=${props.relevance}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.patch(url);
      doRequest.then(
        res => {
          let mergedPropsAndResponse = Object.assign({}, props, res.data);
          dispatch({
            type: UPDATE_COMMENTS_RELEVANT_SUCCESS,
            data: mergedPropsAndResponse,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: UPDATE_COMMENTS_RELEVANT_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_COMMENTS_RELEVANT_BEGIN:
      return {
        ...state,
        updateCommentsRelevantBegin: true,
        updateCommentsRelevantSuccess: false,
        updateCommentsRelevantFailure: false,
        updateFeedsRelevantSuccess: false,
        updateFeedsRelevantFailure: false,
        updateTweetsRelevantSuccess: false,
        updateTweetsRelevantFailure: false,
        updateUploadedCommentsRelevantSuccess: false,
        updateUploadedCommentsRelevantFailure: false,
        commentOrTweetAfterRelevanceUpdates: null
      };
    case UPDATE_COMMENTS_RELEVANT_SUCCESS:
      const commentFeedId = action.data.data[FEED_ID_KEY];
      const updatedComments = state.allComments.data.map(comment => {
        if (comment.commentId === action.data.commentOrPostId) {
          comment.relevance = action.data.relevance;
          state.commentOrTweetAfterRelevanceUpdates = comment;
          state.commentOrTweetAfterRelevanceUpdates[FEED_ID_KEY] = commentFeedId;
        }
        return comment;
      });
      state.allComments.data = updatedComments;
      if (state.feedDetails.data) {
        const updatedFeedModalComments = state.feedDetails.data.map(comment => {
          if (comment.commentId === action.data.commentOrPostId) {
              comment.relevance = action.data.relevance;
              state.commentOrTweetAfterRelevanceUpdates = comment;
              state.commentOrTweetAfterRelevanceUpdates[FEED_ID_KEY] = commentFeedId;
          }
          return comment;
        });
        state.feedDetails.data = updatedFeedModalComments;
      }
      return {
        ...state,
        updateCommentsRelevantBegin: false,
        updateCommentsRelevantSuccess: true,
      };
    case UPDATE_COMMENTS_RELEVANT_FAILURE:
      return {
        ...state,
        updateCommentsRelevantBegin: false,
        updateCommentsRelevantFailure: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/updateCommentsRelevant.js